import React from 'react';
import SearchResultsCount from './SearchResultsCount';
import { FilterActions, FilterActionsHandle } from './FilterActions';
import ClearFiltersButton from './ClearFiltersButton';
import { GlobalFilters } from './globalFilters/GlobalFilters';
import { ViewsDropdown } from '../../settings/viewsManagement/ViewsDropdown';
import { GearFacetValue } from '../../../Model/GearFacets';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { GearFieldForView } from '../../../Model/GearFieldForView';
import { ActiveFilterPills } from './ActiveFilterPills';

interface GearToolbarProps {
  onFilterActionsMount?: (actions: FilterActionsHandle) => void;
  initialFacets?: Record<string, GearFacetValue[]>;
  compositeFilterDescriptor?: CompositeFilterDescriptor;
  columns?: GearFieldForView[];
  onRemoveFilter?: (field: string, value?: string) => void;
}

export const GearToolbar: React.FC<GearToolbarProps> = ({
  onFilterActionsMount,
  initialFacets,
  compositeFilterDescriptor,
  columns,
  onRemoveFilter
}) => {
  return (
    <div className="gearToolbarWrapper">
      <div className="gearToolbar">
        <SearchResultsCount />
        <GlobalFilters initialFacets={initialFacets} />
        <div className="actionButtonsContainer">
          <ViewsDropdown />
          <ClearFiltersButton />
          <FilterActions onMountActions={onFilterActionsMount} />
        </div>
      </div>
      {onRemoveFilter && (
        <div className="activeFiltersRow">
          <ActiveFilterPills
            compositeFilter={compositeFilterDescriptor}
            columns={columns}
            onRemoveFilter={onRemoveFilter}
          />
        </div>
      )}
    </div>
  );
};
